module.exports = "<div>\n  <app-proj-sidebar></app-proj-sidebar>\n  <div class=\"container-fluid\" style=\"padding-left: 85px;\">\n    <h6 class=\"project-title\">\n      {{project_name}}\n    </h6>\n    <small>\n      {{project_description}}\n    </small>\n  </div>\n  <router-outlet></router-outlet>\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project-view/project-view.component.html
// module id = ./src/app/projects/project-view/project-view.component.html
// module chunks = main